import { Component, AfterContentInit, HostBinding, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';

import { environment } from './../environments/environment';
import { FormService } from './api/form.service';
import { AuthService } from './auth.service';
import { DynamicScriptLoaderService } from './api/dynamicscriptloader.service';
import { HelpService } from './api/help.service';
import { LocaleService } from './locale.service';
import { DatadogService } from './modules/shared/datadog/datadog.service';
import { filter } from 'rxjs';
import { UserProfileService } from './api/user-profile.service';

@UntilDestroy()
@Component({
  selector: 'iv-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterContentInit {
  @HostBinding('class.isLoaded')
  isLoaded = false;

  @HostBinding('class.isHomePage')
  isHomePage = false;

  // TODO: inject gaode only when FL goes live in Ali Cloud
  scriptToLoad: string[] = [
    'google',
    // 'gaode'
  ];

  isSalesforceDeepLinking = false;

  constructor(
    private router: Router,
    private formService: FormService,
    private authService: AuthService,
    private dynamicLoader: DynamicScriptLoaderService,
    private helpService: HelpService,
    private localeService: LocaleService,
    private datadogService: DatadogService,
    private userProfileService: UserProfileService,
  ) {
    this.localeService.registerCulture();
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.router.events
      .pipe(
        untilDestroyed(this),
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {

        if (this.authService.getAuthToken()) {
          // Track route change in Datadog RUM
          this.datadogService.setRouteTracking(event);

          // INFO: Set user info in Datadog
          this.datadogService.setUser(
            this.userProfileService.getEmployeeNumberLocalStorage(),
            this.userProfileService.getUserEmailLocalStorage()
          );
        }

        // Reset scroll position
        if (document.body.scrollTop) {
          document.body.scrollTop = 0;
        } else if (document.documentElement.scrollTop) {
          document.documentElement.scrollTop = 0;
        }

        // Reset loadedForms
        this.formService.clearPageForms();
        if (this.router.url === '/') {
          this.isHomePage = true;
          if (!this.authService.getAuthToken()) {
            this.authService.redirectToLoginUrl();
          } else {
            let routeName = '/landing';
            if (environment.datadog.env !== 'local') {
              // const userLocale = window.localStorage.getItem('user_locale');
              let userLocale = window.localStorage.getItem('user_locale');
              if (userLocale === 'en') {
                userLocale = 'en-US';
              }
              if (userLocale && userLocale !== 'en-US') {
                routeName = userLocale + '/landing';
                if (this.authService.getLocaleFromUrl(window.location.pathname) !== userLocale) {
                  window.location.href = environment.finishlineurl + routeName;
                } else {
                  this.router.navigate(['/landing']);
                }
              } else if (userLocale === null || userLocale === undefined) {
                this.router.navigate([routeName]);
              } else {
                this.router.navigate([routeName]);
              }
            } else {
                this.router.navigate([routeName]);
            }
          }
        } else {
          this.isHomePage = false;
          if (this.authService.getAuthToken()) {
            this.helpService.userAuthenticatedSubject.next(true);
            if (this.router.url.includes('opportunity_name') &&
              this.router.url.includes('opportunity_number') &&
              this.router.url.includes('country')) {
              this.isSalesforceDeepLinking = true;
              window.localStorage.setItem('deeplinking_user_locale', this.authService.getLocaleFromUrl(window.location.pathname));
            }

            if (environment.datadog.env !== 'local') {
              let userLocale = window.localStorage.getItem('user_locale');
              if (userLocale === 'en') {
                userLocale = 'en-US';
              }
              if (userLocale === null || userLocale === undefined) {
                this.router.navigate(['/landing']);
              } else {
                if (this.authService.getLocaleFromUrl(window.location.pathname) !== userLocale && !this.isSalesforceDeepLinking) {
                  window.location.href = environment.finishlineurl + userLocale + this.router.url;
                } else if (this.authService.getLocaleFromUrl(window.location.pathname) === userLocale && this.router.url.includes(userLocale)) {
                  // TODO: Double check if we actually need this redirection
                  // this.router.navigate(['/landing']);
                }
              }
            }
          }
        }
      });
  }

  loadScripts() {
    const ctry = window.localStorage.getItem('country');
    switch (ctry) {
      case 'IND':
      case 'CHN':
      case 'THA':
      case 'PHL':
      case 'VNM':
      case 'KOR':
      case 'TWN':
        // load via observable
        this.dynamicLoader.import(this.scriptToLoad)
          .pipe(untilDestroyed(this))
          .subscribe((
            [
              gmapsResponse,
              // gaodeMapsResponse
            ]) => {

          }, (error: any) => {
            console.log(error);
          });
        break;
      default:
        break;
    }
    // load via promise
    // this.dynamicLoader.load(this.scriptToLoad).then(data => {
    // }).catch(error => console.log(error));
  }

  ngOnInit() {
    // this.loadScripts();
  }

  ngAfterContentInit() {
    this.isLoaded = true;
  }
}
